export default {"src":"/_next/static/media/atom.b59933cc.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};